import { Injectable } from '@angular/core';
import { DataUser } from '../inteface';
import { StorageKeyEnum } from '../enum';
import { LANG_OBJ } from '../const';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private static readonly STORAGE_KEYS = {
    progress: 'bk_progress',
    lang: 'bk_lang',
  };
  private dataUser: DataUser = {
    synch: false,
    phone: '',
    lang: 'ru',
    tg: null,
    isPro: false,
    point: 0,
    status: 0,
    chatHistory: [],
    friends: [],
    reminders: [],
    questions: [
      {
        a: [],
        s: 1,
      },
    ],
  };
  statusUser = {};

  constructor() {
    this.hydrateState();
  }

  get user() {
    return this.dataUser;
  }
  set user(user: DataUser) {
    console.log('set user', user);
    this.dataUser = user;
    this.persistState();
  }
  saveUser() {
    this.persistState();
  }
  get stUser() {
    return this.statusUser;
  }
  set stUser(user) {
    this.statusUser = user;
  }

  getUser() {
    return this.dataUser;
  }
  getTgUser() {
    return null;
  }

  updateUser(user: DataUser) {
    this.dataUser = user;
    this.persistState();
    return this.dataUser;
  }

  private hydrateState(): void {
    const storedLang = localStorage.getItem(UserService.STORAGE_KEYS.lang);
    if (storedLang) {
      this.dataUser.lang = storedLang;
    }

    const storedProgress = localStorage.getItem(
      UserService.STORAGE_KEYS.progress
    );
    if (storedProgress) {
      try {
        const parsed = JSON.parse(storedProgress);
        const normalized = this.normalizeQuestions(parsed);
        if (normalized) {
          this.dataUser.questions = normalized;
        }
      } catch {
        // ignore invalid stored progress
      }
    }

    this.migrateLegacyState();
  }

  private persistState(): void {
    const lang = this.dataUser.lang || 'ru';
    localStorage.setItem(UserService.STORAGE_KEYS.lang, lang);

    const questions = Array.isArray(this.dataUser.questions)
      ? this.dataUser.questions
      : [];
    localStorage.setItem(
      UserService.STORAGE_KEYS.progress,
      JSON.stringify(questions)
    );
  }

  private migrateLegacyState(): void {
    const hasLang = !!localStorage.getItem(UserService.STORAGE_KEYS.lang);
    const hasProgress = !!localStorage.getItem(UserService.STORAGE_KEYS.progress);
    if (hasLang && hasProgress) {
      return;
    }

    const legacyUserRaw = localStorage.getItem(StorageKeyEnum.CURRENT_USER);
    if (legacyUserRaw) {
      try {
        const legacyUser = JSON.parse(legacyUserRaw) as Partial<DataUser>;
        if (!hasLang && legacyUser?.lang) {
          this.dataUser.lang = legacyUser.lang;
        }
        if (!hasProgress && legacyUser?.questions) {
          const normalized = this.normalizeQuestions(legacyUser.questions);
          if (normalized) {
            this.dataUser.questions = normalized;
          }
        }
      } catch {
        // ignore invalid legacy payload
      }
    }

    if (!hasLang) {
      const legacyLang = localStorage.getItem(StorageKeyEnum.TUI_LANGUAGE);
      const mapped = this.mapLegacyLang(legacyLang);
      if (mapped) {
        this.dataUser.lang = mapped;
      }
    }

    this.persistState();

    localStorage.removeItem(StorageKeyEnum.CURRENT_USER);
    localStorage.removeItem(StorageKeyEnum.TUI_LANGUAGE);
  }

  private mapLegacyLang(value: string | null): string | null {
    if (!value) {
      return null;
    }
    const normalized = value.toLowerCase();
    if (normalized.length === 2) {
      return normalized;
    }
    const entry = Object.values(LANG_OBJ).find(
      (item) => item.title === normalized
    );
    return entry?.key.toLowerCase() ?? null;
  }

  private normalizeQuestions(value: unknown): DataUser['questions'] | null {
    if (!value) {
      return null;
    }
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === 'object') {
      const asRecord = value as Record<string, { a: string[]; s: number }>;
      const keys = Object.keys(asRecord)
        .map((key) => Number(key))
        .filter((key) => !Number.isNaN(key))
        .sort((a, b) => a - b);
      if (!keys.length) {
        return null;
      }
      return keys.map((key) => asRecord[String(key)]);
    }
    return null;
  }
}
